import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  state: {
    itemModal: false,
    imgUploadModal: false,
    loadingItemAction: false,
    imgUploadImage: '',
    imgUploadIndex: 0,
    itemVariationImage: {
      imageCropH: 0,
      imageCropW: 0,
      imageCropX: 0,
      imageCropY: 0
    },
    selectedItem: {
      id: '',
      name: '',
      code: '',
      description: '',
      termsOfUseContent: '',
      realizationTime: '',
      active: '',
      tags: '',
      categoriesWithRegister: '',
      categories: '',
      family: '',
      seq: 0,
      validityStart: '',
      validityEnd: '',
      price: null,
      priceVariations: '',
      idProvider: '',
      priceTable: '',
      payment: '',
      image: '',
      images: [],
      imageCropH: 0,
      imageCropW: 0,
      imageCropX: 0,
      imageCropY: 0,
      needSchedule: false,
      customTime: false,
      weekDayStart: '',
      weekDayEnd: '',
      weekDayInterval: '',
      weekDayCapacity: 0,
      sundayStart: '',
      sundayEnd: '',
      sundayInterval: '',
      sundayCapacity: 0,
      mondayStart: '',
      mondayEnd: '',
      mondayInterval: '',
      mondayCapacity: 0,
      tuesdayStart: '',
      tuesdayEnd: '',
      tuesdayInterval: '',
      tuesdayCapacity: 0,
      wednesdayStart: '',
      wednesdayEnd: '',
      wednesdayInterval: '',
      wednesdayCapacity: 0,
      thursdayStart: '',
      thursdayEnd: '',
      thursdayInterval: '',
      thursdayCapacity: 0,
      fridayStart: '',
      fridayEnd: '',
      fridayInterval: '',
      fridayCapacity: 0,
      saturdayStart: '',
      saturdayEnd: '',
      saturdayInterval: '',
      saturdayCapacity: 0
    },
    imageNotSent: '',
    registeredItems: [],
    cupoms: [],
    cupomCurrentPage: 1,
    cupomTotalItems: 0,
    cupomTotalPages: 0,
    cupomPaginaInicial: 0,
    cupomPaginaFinal: 0,
    cupomItemsPerPage: 12,
    selectedCupom: {
      id: 0,
      name: '',
      idFornecedor: 0,
      type: 0,
      amount: 0,
      code: null,
      start: null,
      end: null,
      limitationType: 0,
      limitation: null,
      observation: '',
      region: false,
      administradoras: false,
      condominios: false,
      produtos: false,
      active: false,
      approved: false,
      servicoProdutosList: null
    },
    cupomModal: false,
    loadingCupomAction: false
  },
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/item/index.js